import initialState from './initialState';

const ticketsReducer = (state = initialState.tickets, action) => {
    switch (action.type) {
        case 'TICKETS_SUCCESS':
            return {
                ...state,
                all: action.tickets,
                count: parseInt(action.count)
            };
        case 'TICKETS_DELETE_SUCCESS':
            return {
                ...state,
                all: state.all.filter(stateItem => stateItem.id !== action.id)
            };
        case 'GET_REGISTERED_TICKET_SUCCESS':
            return {
                ...state,
                notAnsweredCount: (action.data.tickets[0].unanswered),
                loading: false,
            };
        case 'GET_REGISTERED_TICKET_FAILURE':
            return {
                ...state,
                notAnsweredCount: 0,
                loading: false,
            };
        default:
            return state;
    }
};

export default ticketsReducer;
